import axios from 'axios';
import {auth} from '../../firebase/firebase';

const baseURL = 'https://keeplaying-server.azurewebsites.net/';

const apiClient = axios.create({baseURL});

// Attach the current Firebase ID token (if any) to every outgoing request so
// the server can identify the caller. Guests send no header and hit public
// routes only — protected routes 401 without it.
apiClient.interceptors.request.use(async config => {
    const user = auth.currentUser;
    if (user) {
        const token = await user.getIdToken();
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default apiClient;
